import type { SuggestData } from '@/models/interface/learningStatistics';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class LessonSuggestService extends ApiFactory {
  constructor() {
    super('UserReports');
  }

  fetchLessonSuggest(): Promise<ApiDataResponse<SuggestData[]>> {
    return super.get('LearningProcess');
  }
}
